import React from 'react';

interface EightMeterSectionProps {
  onUs: () => void;
  onThem: () => void;
  disabled?: boolean;
}

const EightMeterSection: React.FC<EightMeterSectionProps> = ({ onUs, onThem, disabled = false }) => (
  <div className="z-10">
    <div className="relative text-2xl font-bold text-center z-10">8 Meter Free Possession</div>
    <div className="relative flex w-full justify-between items-stretch gap-4 z-10 pt-3 px-3">
      <button
        type="button"
        className={`flex-1 font-bold rounded-lg px-3 py-4 text-center shadow-lg bg-sd-green text-black text-xl sm:text-2xl ${
          disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:scale-105 transition-transform'
        }`}
        onClick={onUs}
        disabled={disabled}
      >
        US
      </button>
      <button
        type="button"
        className={`flex-1 font-bold rounded-lg px-3 py-4 text-center shadow-lg bg-sd-navy text-white text-xl sm:text-2xl ${
          disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:scale-105 transition-transform'
        }`}
        onClick={onThem}
        disabled={disabled}
      >
        THEM
      </button>
    </div>
  </div>
);

export default EightMeterSection;
